import React from 'react';

import {PlanSelection} from 'presentation/pages';

export const MakePlanSelection: React.FC = () => <PlanSelection />;
